import '@fontsource/dancing-script';
import Cropper from 'react-easy-crop';
import { ConfigProvider, useConfig } from '../ConfigContext';
import Controls from './Controls';
// import Preview from "./Preview";
import { importDataFromUrl } from '../../services/env';
import Preview from './Preview';
import React, { useEffect } from 'react';
import { TypeSelector } from './Controls/TypeSelector';
import AdminPanel from './Controls/AdminPanel'; // načtení URL parametrů + přihl. user log

function ConfiguratorInner() {
  const {
    general,
    setGeneralState,
    setMusicState,
    setSocialsState,
    setMultipleConfigState,
    setCroppers,
    setCroppersCount,
    setMultipleGap,
    setSelectedLayout,
  } = useConfig();

  // import konfigurace z ?config=... &edit=...
  useEffect(() => {
    importDataFromUrl({
      general,
      setGeneralState,
      setMusicState,
      setSocialsState,
      setMultipleConfigState,
      setCroppers,
      setCroppersCount,
      setMultipleGap,
      setSelectedLayout,
    });
  }, []);

  return (
    <div
      className="container"
      style={{
        // backgroundColor: '#f1f1f1',
        margin: 'auto',
      }}
    >
      <TypeSelector />
      <div className="main_layout">
        <div
          className="md:mx-2"
          style={{
            gridArea: 'controls',
            backgroundColor: '#ffffff',
            borderRadius: 10,
            border: '1px solid #ccc',
            padding: '1vw',
          }}
        >
          <Controls Cropper={Cropper} />
        </div>
        <div
          style={{
            gridArea: 'preview',
          }}
        >
          <Preview Cropper={Cropper} />
        </div>
      </div>
      {general.isAdmin && <AdminPanel />}
    </div>
  );
}

export function NewGlassBoardConfigurator() {
  return <ConfiguratorInner />;
}
